import {
  Container,
  Card,
  Text,
  Button,
  Box,
  VStack,
  HStack,
  Image,
} from "@chakra-ui/react";
import { useRef } from "react";
import { useLocation } from "react-router-dom";
import { useReactToPrint } from "react-to-print";

export default function PrintMembership2() {
  const componentRef = useRef();

  const { state } = useLocation();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <>
      <Container maxW="5xl" my="2">
        <VStack>
          <Card p="5" w="100%">
            <HStack justifyContent="space-between" w="100%">
              <Text fontWeight="800">Membership Details</Text>
              <Button onClick={handlePrint}>Print</Button>
            </HStack>
          </Card>

          <Box
            bg="white"
            ref={componentRef}
            shadow="md"
            style={{
              height: "auto",
              width: "21cm",
              aspectRatio: "1.41/1",
              fontSize: "small",
            }}
          >
            <VStack>
              <Container
                bg="white"
                width="100%"
                maxW="100%"
                style={{ height: "29.7cm" }}
              >
                <VStack spacing={"3"}>
                  <Box
                    w="100%"
                    p="4"
                    bg="#641344"
                    alignItems="center"
                    display="flex"
                    justifyContent="center"
                  >
                    {/* <HStack justifyContent='space-between' w='100%'>
                                            <Image border='0px solid #1c1c1c' alt='Logo' src='/logo-white.png' w='250px' />
                                            <Image border='0px solid #1c1c1c' alt='Logo' src='/logo2.png' w='250px' />
                                        </HStack> */}
                    <HStack justifyContent="space-between" w="100%">
                      <Image
                        border="0px solid #1c1c1c"
                        alt="Logo"
                        src="/logo-white_old.png"
                        w="220px"
                      />
                      <Image
                        border="0px solid #1c1c1c"
                        alt="Logo"
                        src="/logo-white.png"
                        w="120px"
                      />
                    </HStack>
                  </Box>

                  <VStack>
                    <Text fontSize="4xl" fontFamily="customfont">
                      BORN TO SHINE ENROLLMENT FORM
                    </Text>

                    {/* <Text fontSize='sm' textAlign='center'>The Invest and Shine Subscription Plan ( hereinafter "Invest & Share" or "Subscription Plan" ) offered by Limelight Lab Grown Diamonds Limited ("Limelight" or the "Company") is introduced to enable Customers to purchase Limelight jewellery and pay for the same over a 10(ten) months period ("Investement Tenure" or "Tenure") and avail certain discounts subject to the Terms and Conditions.</Text> */}
                  </VStack>

                  <HStack justifyContent="space-between" w="100%">
                    <HStack>
                      <Text>ID NO : {state.id_number}</Text>
                    </HStack>

                    <HStack>
                      <Text>Enrollment Date: {state.enrollment_date}</Text>
                    </HStack>
                  </HStack>

                  <HStack justifyContent="space-between" w="100%">
                    <HStack>
                      <Text>Mobile Number : {state.phone}</Text>
                    </HStack>

                    <HStack>
                      <Text>Exp Date: {state.expiry_date}</Text>
                    </HStack>
                  </HStack>

                  <Card
                    borderRadius="md"
                    width={"100%"}
                    bg="primary.800"
                    colorScheme="primary"
                  >
                    <Text
                      fontWeight="500"
                      className="customfont"
                      p={3}
                      fontSize="lg"
                      color={"white"}
                    >
                      Personal Information
                    </Text>
                  </Card>

                  <table
                    style={{
                      width: "20cm",
                      tableLayout: "fixed",
                      backgroundColor: "white",
                      fontSize: "9px !important",
                      textAlign: "start",
                      alignItems: "start",
                    }}
                  >
                    <tbody style={{ textAlign: "start" }}>
                      <tr>
                        <td
                          style={{
                            backgroundColor: "white",
                            textAlign: "start",
                          }}
                        >
                          Name :{" "}
                        </td>
                        <td
                          style={{
                            backgroundColor: "white",
                            textAlign: "start",
                          }}
                        >
                          {state.name}
                        </td>
                        <td
                          style={{
                            backgroundColor: "white",
                            textAlign: "start",
                          }}
                        >
                          Date Of Birth :{" "}
                        </td>
                        <td
                          style={{
                            backgroundColor: "white",
                            textAlign: "start",
                          }}
                        >
                          {state.date_of_birth}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            backgroundColor: "white",
                            textAlign: "start",
                          }}
                        >
                          Address :{" "}
                        </td>
                        <td
                          style={{
                            backgroundColor: "white",
                            textAlign: "start",
                          }}
                          colSpan={3}
                        >
                          {state.address}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            backgroundColor: "white",
                            textAlign: "start",
                          }}
                        >
                          Email :{" "}
                        </td>
                        <td
                          style={{
                            backgroundColor: "white",
                            textAlign: "start",
                          }}
                          colSpan={3}
                        >
                          {state.e_mail}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            backgroundColor: "white",
                            textAlign: "start",
                          }}
                        >
                          Gender :{" "}
                        </td>
                        <td
                          style={{
                            backgroundColor: "white",
                            textAlign: "start",
                          }}
                        >
                          {state.gender}
                        </td>
                        <td
                          style={{
                            backgroundColor: "white",
                            textAlign: "start",
                          }}
                        >
                          Enrolled By :{" "}
                        </td>
                        <td
                          style={{
                            backgroundColor: "white",
                            textAlign: "start",
                          }}
                        >
                          {state.enrolled_by}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            backgroundColor: "white",
                            textAlign: "start",
                          }}
                        >
                          ID Proof :{" "}
                        </td>
                        <td
                          style={{
                            backgroundColor: "white",
                            textAlign: "start",
                          }}
                        >
                          {state.user_id_proof}
                        </td>
                        <td
                          style={{
                            backgroundColor: "white",
                            textAlign: "start",
                          }}
                        >
                          ID Number :{" "}
                        </td>
                        <td
                          style={{
                            backgroundColor: "white",
                            textAlign: "start",
                          }}
                        >
                          {state.user_id_no}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            backgroundColor: "white",
                            textAlign: "start",
                          }}
                        >
                          City :{" "}
                        </td>
                        <td
                          style={{
                            backgroundColor: "white",
                            textAlign: "start",
                          }}
                        >
                          {state.city}
                        </td>
                        <td
                          style={{
                            backgroundColor: "white",
                            textAlign: "start",
                          }}
                        >
                          Pincode :{" "}
                        </td>
                        <td
                          style={{
                            backgroundColor: "white",
                            textAlign: "start",
                          }}
                        >
                          {state.pincode}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            backgroundColor: "white",
                            textAlign: "start",
                          }}
                        >
                          Nominee Name :{" "}
                        </td>
                        <td
                          style={{
                            backgroundColor: "white",
                            textAlign: "start",
                          }}
                        >
                          {state.nominee_name}
                        </td>
                        <td
                          style={{
                            backgroundColor: "white",
                            textAlign: "start",
                          }}
                        >
                          Relationship With Holder :{" "}
                        </td>
                        <td
                          style={{
                            backgroundColor: "white",
                            textAlign: "start",
                          }}
                        >
                          {state.nominee_relationship}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            backgroundColor: "white",
                            textAlign: "start",
                          }}
                        >
                          ID Number :{" "}
                        </td>
                        <td
                          style={{
                            backgroundColor: "white",
                            textAlign: "start",
                          }}
                        >
                          {state.nominee_id_no}
                        </td>
                        <td
                          style={{
                            backgroundColor: "white",
                            textAlign: "start",
                          }}
                        >
                          ID Proof :{" "}
                        </td>
                        <td
                          style={{
                            backgroundColor: "white",
                            textAlign: "start",
                          }}
                        >
                          {state.nominee_id_proof}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            backgroundColor: "white",
                            textAlign: "start",
                            fontSize: "9px !important",
                          }}
                        >
                          Mobile Number :{" "}
                        </td>
                        <td
                          style={{
                            backgroundColor: "white",
                            textAlign: "start",
                            fontSize: "9px !important",
                          }}
                        >
                          {state.nominee_phone}
                        </td>
                        <td
                          style={{
                            backgroundColor: "white",
                            textAlign: "start",
                            fontSize: "9px !important",
                          }}
                        >
                          Authorized Store :{" "}
                        </td>
                        <td
                          style={{
                            backgroundColor: "white",
                            textAlign: "start",
                            fontSize: "9px !important",
                          }}
                        >
                          {state.branch}
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  {/* 
                                    <HStack w='100%' alignItems='center' justifyContent='space-between'>

                                        <HStack width='450px'>
                                            <Text w='200px'>Name</Text>
                                            <Text w='100%'>: {state.name}</Text>
                                        </HStack>


                                        <HStack width='450px' alignItems='start'>
                                            <Text w='200px'>Address</Text>
                                            <Text w='100%'>: {state.address}</Text>
                                        </HStack>
                                    </HStack>


                                    <HStack w='100%' alignItems='center'>
                                        <HStack width='450px'>
                                            <Text w='200px'>Date of Birth</Text>
                                            <Text w='100%'>: {state.date_of_birth}</Text>
                                        </HStack>

                                        <HStack width='450px'>

                                        </HStack>
                                    </HStack>


                                    <HStack w='100%'>
                                        <HStack width='450px'>
                                            <Text w='200px'>Gender</Text>
                                            <Text w='100%'>: {state.gender}</Text>
                                        </HStack>

                                        <HStack width='450px'>
                                            <Text w='200px'>City</Text>
                                            <Text w='100%'>: {state.city}</Text>
                                        </HStack>
                                    </HStack>

                                    <HStack w='100%'>
                                        <HStack width='450px' maxW='450px' overflowWrap='anywhere' bg='red'>
                                            <Text w='200px'>E Mail</Text>
                                            <Text w='100%'>: {state.e_mail}</Text>
                                        </HStack>

                                        <HStack width='450px' bg='red'>
                                            <Text w='200px'>Pincode</Text>
                                            <Text w='100%'>: {state.pincode}</Text>
                                        </HStack>
                                    </HStack>


                                    <HStack w='100%'>
                                        <HStack width='450px'>
                                            <Text w='200px'>ID Proof</Text>
                                            <Text w='100%'>: {state.user_id_proof}</Text>
                                        </HStack>

                                        <HStack width='450px'>
                                            <Text w='200px'>ID Number</Text>
                                            <Text w='100%'>: {state.user_id_no}</Text>
                                        </HStack>
                                    </HStack> */}

                  {/* <HStack w='100%'>
                                        <HStack width='450px'>
                                            <Text w='200px'>Nominee Name</Text>
                                            <Text w='100%'>: {state.nominee_name}</Text>
                                        </HStack>

                                        <HStack width='450px'>
                                            <Text w='200px'>Enrolled By</Text>
                                            <Text w='100%'>: {state.enrolled_by}</Text>
                                        </HStack>
                                    </HStack>

                                    <HStack w='100%'>
                                        <HStack width='450px'>
                                            <Text w='200px'>Relationship With Holder</Text>
                                            <Text w='100%'>: {state.nominee_relationship}</Text>
                                        </HStack>

                                        <HStack width='450px'>
                                            <Text w='200px'>Authorized Store</Text>
                                            <Text w='100%'>: {state.branch}</Text>
                                        </HStack>
                                    </HStack>




                                    <HStack w='100%'>

                                        <HStack width='450px'>
                                            <Text w='200px'>Mobile Number</Text>
                                            <Text w='100%'>: {state.nominee_phone}</Text>
                                        </HStack>

                                        <HStack width='450px'>
                                        </HStack>

                                    </HStack>

                                    <HStack w='100%'>
                                        <HStack width='450px'>
                                            <Text w='200px'>ID Proof</Text>
                                            <Text w='100%'>: {state.nominee_id_proof}</Text>
                                        </HStack>

                                        <HStack width='450px'>
                                            <Text w='200px'>ID Number</Text>
                                            <Text w='100%'>: {state.nominee_id_no}</Text>
                                        </HStack>
                                    </HStack> */}

                  <Card
                    borderRadius="md"
                    width={"100%"}
                    bg="primary.800"
                    colorScheme="primary"
                  >
                    <Text
                      fontWeight="500"
                      className="customfont"
                      p={3}
                      fontSize="lg"
                      color={"white"}
                    >
                      Subscription Plan Selection
                    </Text>
                  </Card>

                  <HStack w="100%">
                    <Text w="200px">Selected Plan</Text>
                    <Text w="100%">: {state.scheme_name}</Text>
                  </HStack>

                  <HStack w="100%">
                    <Text w="200px">Monthly Installment</Text>
                    <Text w="100%">: {state.monthly_price}</Text>
                  </HStack>

                  <HStack w="100%">
                    <Text w="200px">Installment</Text>
                    <Text w="100%">: {state.installments}</Text>
                  </HStack>

                  <HStack w="100%">
                    <Text w="200px">Enrollment Date</Text>
                    <Text w="100%">: {state.enrollment_date}</Text>
                  </HStack>

                  <HStack w="100%">
                    <Text w="200px">Branch</Text>
                    <Text w="100%">: {state.branch}</Text>
                  </HStack>
                </VStack>
              </Container>

              <Container
                bg="white"
                width="100%"
                maxW="100%"
                style={{ height: "29.5cm", aspectRatio: "1.41/1" }}
              >
                <VStack w="100%">
                  <Card
                    borderRadius="md"
                    width={"100%"}
                    bg="primary.800"
                    colorScheme="primary"
                  >
                    <Text
                      fontWeight="500"
                      className="customfont"
                      p={3}
                      fontSize="lg"
                      color={"white"}
                    >
                      Terms & Conditions
                    </Text>
                  </Card>
                  <ul style={{ padding: "12px", fontSize: "9.5px" }}>
                    <li>
                      Introducing the “Born to Shine” subscription plan
                      (hereinafter referred to as the “Subscription Plan”), a
                      customer jewellery purchase programme offered by Limelight
                      Lab Grown Diamonds Limited (“Limelight” or the “Company”).
                      The Subscription Plan enables eligible customers
                      (“Customer(s)”) to make monthly instalment payments over a
                      specified tenure and avail the benefits associated with
                      the Subscription Plan towards the purchase of eligible
                      jewellery products from authorized Limelight stores,
                      subject to these terms mentioned herein (“Terms and
                      Conditions”).
                    </li>

                    <li>
                      These Terms and Conditions constitute the agreement
                      governing the Scheme. Participation in or availing of the
                      Scheme by a Customer shall be deemed to constitute the
                      Customer's acceptance of and agreement to be bound by
                      these Terms and Conditions.
                    </li>

                    <li>
                      1. Under the Subscription Plan, eligible customers may
                      enroll in a plan offered by the Company and make monthly
                      instalment payments for a period of 10 (ten) months
                      (“Tenure”). Upon successful completion of the Tenure and
                      subject to compliance with these Terms and Conditions, the
                      Customer shall be entitled to avail the benefits
                      applicable to the selected plan in accordance with the
                      Terms and Conditions.
                    </li>

                    <li>
                      2. The Customer shall enroll in a plan offered by the
                      Company and pay the applicable monthly instalment amount
                      communicated at the time of enrolment by the Company. The
                      monthly instalment amount applicable to the selected plan
                      shall remain fixed throughout the Tenure and no payment of
                      a lesser amount shall be accepted towards any monthly
                      instalment. Acceptance of any payment exceeding the
                      prescribed monthly instalment amount shall be at the sole
                      discretion of the Company and subject to the Company’s
                      prevailing policies.
                    </li>

                    <li>
                      3. To enroll in the Subscription Plan, the Customer shall
                      open a subscription account (“Subscription Account”) at
                      any authorized Limelight store by completing the enrolment
                      formalities prescribed by the Company. The Company and/or
                      its authorized representatives may assist the Customer in
                      the enrolment process. A Customer may open and maintain
                      multiple Subscription Accounts under the Subscription
                      Plan; however, each Subscription Account shall be treated
                      as separate and independent, with its own rights,
                      obligations, benefits and liabilities.
                    </li>

                    <li>
                      4. To be eligible to enroll in the Subscription Plan, the
                      Customer must be at least 18 (eighteen) years of age, be a
                      resident of India, and furnish such identity proof,
                      address proof, PAN card, Aadhaar card and other documents
                      or information as may be required by the Company for
                      verification, compliance and activation of the
                      Subscription Account. The Customer represents and warrants
                      that all information and documents provided to the Company
                      are true, accurate, complete and up to date. It is hereby
                      clarified that the Subscription Plan is available only to
                      Indian resident individuals and is not available to
                      companies, partnership firms, proprietorship concerns,
                      trusts, Hindu Undivided Families (HUFs), non-resident
                      Indians (NRIs) or any other artificial juridical persons.
                    </li>

                    <li>
                      5. The Customer shall make the first monthly instalment at
                      the time of opening the Subscription Account. The date on
                      which the first instalment is received by the Company
                      shall be deemed to be the enrolment date (“Enrolment
                      Date”).
                    </li>

                    <li>
                      6. Upon successful payment of all 10 (ten) monthly
                      instalments within the Tenure and compliance with these
                      Terms and Conditions, the Company shall contribute an
                      amount equivalent to 1 (one) monthly instalment on behalf
                      of the Customer and issue a voucher equivalent to the
                      aggregate value of 11 (eleven) monthly instalments. The
                      Company's contribution of the additional monthly
                      instalment shall constitute the sole benefit under the
                      Subscription Plan, and no other discount, rebate,
                      cashback, reward points, price reduction, making charge
                      waiver or similar benefit shall be available unless
                      expressly permitted by the Company in writing.
                    </li>

                    <li>
                      7. The Subscription Account shall remain valid for a
                      period of 400 (four hundred) days from the Enrolment Date
                      (“Subscription End Date”). During the Tenure, the Customer
                      shall pay the applicable monthly instalment on or before
                      the corresponding date of each subsequent month (“Due
                      Date”). Any overdue instalment may be paid along with the
                      subsequent instalment, subject to the Subscription Account
                      remaining active and compliant with these Terms and
                      Conditions. In the event the Customer fails to pay 2 (two)
                      consecutive monthly instalments, the Company shall have
                      the right to terminate the Subscription Account without
                      any further notice, and the Customer’s rights shall
                      thereafter be governed in accordance with the cancellation
                      provisions of these Terms and Conditions. Upon such
                      termination, the Customer shall not be entitled to the
                      benefit of the additional monthly instalment contributed
                      by the Company, and the Company shall issue a voucher
                      equivalent only to the amount actually paid by the
                      Customer under the Subscription Plan. Such voucher shall
                      be subject to the terms, conditions and validity
                      applicable under the Subscription Plan.
                    </li>

                    <li>
                      8. The benefits under the Subscription Plan shall be
                      available only if:
                      <ul style={{ padding: "0 30px" }}>
                        <li>
                          a. all instalments have been paid in accordance with
                          the Subscription Plan;
                        </li>
                        <li>
                          b. the Subscription Account remains active and
                          compliant with these Terms and Conditions;
                        </li>
                        <li>
                          c. redemption is completed on or before the
                          Subscription End Date; and
                        </li>
                        <li>
                          d. the purchase is made from an authorized Limelight
                          store as per the terms of the issued voucher/coupon.
                        </li>
                      </ul>
                    </li>

                    <li>
                      9. A voucher issued under the Subscription Plan may be
                      redeemed only once towards the purchase of eligible
                      jewellery products from authorized Limelight stores. Where
                      the purchase value exceeds the voucher amount, the
                      Customer shall pay the differential amount through such
                      payment modes as may be accepted by the Company. In the
                      event the purchase value is less than voucher amount, the
                      unutilized voucher balance shall lapse and shall not be
                      refundable, credited or carried forward in anyway
                      whatsoever.
                    </li>

                    <li>
                      10. The Subscription Account is personal to the Customer,
                      non-transferable and non-assignable. Upon expiry of the
                      Subscription End Date, the Subscription Account shall
                      automatically stand closed.
                    </li>

                    <li>
                      11. The Customer may nominate an individual above the age
                      of 18 (eighteen) years at the time of enrolment. In the
                      event of the Customer's death, the nominee may, subject to
                      verification and submission of documents as required by
                      the Company, continue the Subscription Plan, pay any
                      pending instalments and redeem the benefits available
                      under the Subscription Plan.
                    </li>

                    <li>
                      12. Instalments shall be paid through such payment modes
                      as may be approved by the Company including but limited to
                      UPI, cash payments at authorized Limelight stores. The
                      Company shall not be liable for delays, failures or
                      interruptions attributable to banks, payment gateways or
                      third-party payment service providers.
                    </li>

                    <li>
                      13. In the event the Customer voluntarily discontinues,
                      cancels or terminates participation in the Subscription
                      Plan prior to completion of the Tenure, no cash refund
                      shall be provided. The Company shall issue a voucher
                      equivalent to the amount paid by the Customer under the
                      Subscription Plan, which may be utilized by the Customer
                      within 6 (six) months from the date of voucher issuance or
                      before Subscription End Date, whichever is earlier,
                      subject to such usage restrictions and conditions as may
                      be prescribed by the Company.
                    </li>

                    <li>
                      14. If the Customer fails to redeem the accumulated value
                      under the Subscription Plan on or before the Subscription
                      End Date, the Subscription Account shall automatically
                      stand closed. Upon such closure, the Company may refund
                      the principal amount paid by the Customer under the
                      Subscription Plan through the prescribed banking channels,
                      without any interest. The additional benefit equivalent to
                      1 (one) monthly instalment contributed by the Company
                      shall not be provided to the Customer in cash and shall
                      instead be issued as a voucher of equivalent value, valid
                      for 6 (six) months from the date of issuance. Such voucher
                      may be utilized only towards the purchase of eligible
                      jewellery products after the Customer has fully utilized
                      the refunded principal amount and shall be
                      non-transferable, non-refundable and subject to the
                      Company's applicable terms and conditions.
                    </li>

                    <li>
                      15. Except as expressly provided under Clause 14, the
                      Customer shall not be entitled to any cash refund, bank
                      transfer, interest, return, compensation or monetary
                      payout against any amount paid under the Subscription
                      Plan. The Customer's entitlements under the Subscription
                      Plan shall be limited to redemption and/or utilization of
                      vouchers issued in accordance with these Terms and
                      Conditions. In exceptional circumstances, including but
                      not limited to cancellation of the Subscription Account by
                      the Company due to discrepancies in Customer information,
                      failure to complete KYC requirements, regulatory
                      requirements, fraud prevention measures, breach of these
                      Terms and Conditions, or any other circumstance where the
                      Company determines that issuance of a voucher is not
                      feasible, the Company may, at its sole discretion, refund
                      the amount paid by the Customer under the Subscription
                      Plan.
                    </li>

                    <li>
                      16. Any refund approved by the Company shall be made only
                      through electronic transfer by way of NEFT, RTGS or such
                      other banking channel as may be determined by the Company,
                      to the bank account details provided by the Customer and
                      duly verified by the Company. The mode, timing and process
                      of such refund shall be determined by the Company in
                      accordance with its prevailing internal policies and
                      applicable laws.
                    </li>

                    <li>
                      17. Coins, loose solitaires, plain gold products,
                      MRP-based products, accessories and such other products as
                      may be specified by the Company at the time of redemption
                      shall not be eligible for purchase under the Subscription
                      Plan.
                    </li>

                    {/* <li>
                      18. The benefits available under the Subscription Plan may
                      be combined with promotional campaigns, festive offers and
                      marketing programmes expressly approved by the Company.
                      However, the Subscription Plan shall not be combined with
                      the “Redefine” scheme or any other offer specifically
                      excluded by the Company at its discretion.
                    </li> */}

                    {/* <li>
                      19. The Company reserves the right to suspend, reject,
                      cancel or terminate a Subscription Account in the event of
                      fraud, misrepresentation, submission of inaccurate
                      information, failure to complete KYC requirements, breach
                      of these Terms and Conditions or any unlawful activity. In
                      such cases, the Company may at its discretion issue a
                      voucher equivalent to the amount paid by the Customer.
                    </li>

                    <li>
                      20. The Customer shall promptly notify the Company of any
                      change in name, address, contact details, banking
                      information or any other information provided at the time
                      of enrolment.
                    </li>

                    <li>
                      21. The Company reserves the right to modify, amend or
                      discontinue the Subscription Plan, provided that such
                      modification shall not adversely affect benefits already
                      accrued by Customers who have enrolled prior to such
                      modification.
                    </li>

                    <li>
                      22. The Subscription Plan is a customer jewellery purchase
                      programme and shall not be construed as a deposit scheme,
                      investment scheme, savings scheme, chit fund, collective
                      investment scheme, financial product or banking product.
                      No interest shall accrue or be payable on any amount paid
                      by the Customer under the Subscription Plan.
                    </li>

                    <li>
                      23. The Company's aggregate liability arising out of or in
                      connection with the Subscription Plan shall in no event
                      exceed the total amount paid by the Customer under the
                      Subscription Plan. In no event shall the Company be liable
                      for any indirect, incidental, special, punitive or
                      consequential loss or damage, including loss of profits,
                      business, goodwill or data, arising out of or in
                      connection with the Subscription Plan
                    </li>

                    <li>
                      24. The Company shall not be liable for any delay or
                      failure in performance arising due to events beyond its
                      reasonable control, including acts of God, natural
                      disasters, governmental actions, pandemics, strikes, labor
                      disputes, system failures, cyber incidents or
                      interruptions in communication networks.
                    </li>

                    <li>
                      25. The Customer expressly consents to the collection,
                      storage, processing, use and retention of their personal
                      information, contact details and documents by the Company
                      for the purposes of enrolment, administration and
                      operation of the Subscription Plan, verification of
                      identity, customer support, compliance with applicable
                      laws, and such other business purposes as may be
                      reasonably required by the Company. The Customer further
                      authorizes the Company and its affiliates, group
                      companies, franchisees, authorized representatives and
                      service providers to contact the Customer through
                      telephone calls, SMS, WhatsApp, e-mail or other
                      communication channels regarding products, jewellery
                      collections, promotional campaigns, offers, subscription
                      plans, loyalty programmes and other marketing initiatives.
                      Such collection, storage, processing and use of personal
                      information shall be subject to the Company's privacy
                      policy and applicable laws.
                    </li>

                    <li>
                      26. Any matter not expressly covered under these Terms and
                      Conditions shall be determined by the Company.
                    </li>

                    <li>
                      27. The Company’s prevailing return, exchange, buyback and
                      product warranty policies shall apply to all purchases
                      made under the Subscription Plan.
                    </li>

                    <li>
                      28. These Terms and Conditions shall be governed by and
                      construed in accordance with the laws of India and the
                      courts at Mumbai shall have exclusive jurisdiction over
                      any dispute arising out of or in connection with the
                      Subscription Plan.
                    </li>

                    <li>
                      29. No failure, delay or omission by the Company in
                      exercising any right, power, remedy or privilege under
                      these Terms and Conditions shall operate as a waiver
                      thereof, nor shall any single or partial exercise of any
                      such right, power, remedy or privilege preclude any other
                      or further exercise thereof or the exercise of any other
                      right, power, remedy or privilege. Any waiver by the
                      Company shall be valid only if made expressly in writing
                      and shall apply only to the specific instance for which
                      such waiver is granted.
                    </li>

                    <li>
                      30. If any provision of these Terms and Conditions is held
                      to be invalid, illegal, unenforceable or void by a court
                      or other competent authority, such provision shall, to the
                      extent of such invalidity, illegality or unenforceability,
                      be deemed severed from these Terms and Conditions without
                      affecting the validity, legality or enforceability of the
                      remaining provisions, which shall continue in full force
                      and effect. The parties intend that any such invalid,
                      illegal or unenforceable provision shall be interpreted
                      or, where necessary, replaced with a valid and enforceable
                      provision that most closely reflects the original
                      commercial intent of the parties, to the extent permitted
                      by applicable law.
                    </li>

                    <li>
                      31. All applicable taxes, statutory levies and regulatory
                      requirements shall apply. Any query, complaint or
                      grievance relating to the Subscription Plan may be
                      addressed to the Company`s Grievance Officer at
                      ______________ (E-mail) or ____________ (Customer Care
                      Number), or at the authorized Limelight store in writing
                      where the Subscription Account was opened.
                    </li> */}
                  </ul>

                  {/* <HStack justifyContent="space-around" w="100%" mt="8">
                    <VStack spacing="2">
                      <Box w="200px" h="1px" bg="black" />
                      <Text fontSize="10px">Authorized Signature</Text>
                      <Text fontSize="10px">
                        Date : {state.enrollment_date}
                      </Text>
                    </VStack>

                    <VStack spacing="2">
                      <Box w="200px" h="1px" bg="black" />
                      <Text fontSize="10px">Customer Signature</Text>
                      <Text fontSize="10px">
                        Date : {state.enrollment_date}{" "}
                      </Text>
                    </VStack>
                  </HStack> */}
                </VStack>
              </Container>

              <Container
                bg="white"
                width="100%"
                maxW="100%"
                style={{ height: "29.5cm", aspectRatio: "1.41/1" }}
              >
                <VStack w="100%">
                  <ul style={{ padding: "12px", fontSize: "9.5px" }}>
                    {/* <li>
                      Introducing the “Born to Shine” subscription plan
                      (hereinafter referred to as the “Subscription Plan”), a
                      customer jewellery purchase programme offered by Limelight
                      Lab Grown Diamonds Limited (“Limelight” or the “Company”).
                      The Subscription Plan enables eligible customers
                      (“Customer(s)”) to make monthly instalment payments over a
                      specified tenure and avail the benefits associated with
                      the Subscription Plan towards the purchase of eligible
                      jewellery products from authorized Limelight stores,
                      subject to these terms mentioned herein (“Terms and
                      Conditions”).
                    </li>

                    <li>
                      These Terms and Conditions constitute the agreement
                      governing the Scheme. Participation in or availing of the
                      Scheme by a Customer shall be deemed to constitute the
                      Customer's acceptance of and agreement to be bound by
                      these Terms and Conditions.
                    </li>

                    <li>
                      1. Under the Subscription Plan, eligible customers may
                      enroll in a plan offered by the Company and make monthly
                      instalment payments for a period of 10 (ten) months
                      (“Tenure”). Upon successful completion of the Tenure and
                      subject to compliance with these Terms and Conditions, the
                      Customer shall be entitled to avail the benefits
                      applicable to the selected plan in accordance with the
                      Terms and Conditions.
                    </li>

                    <li>
                      2. The Customer shall enroll in a plan offered by the
                      Company and pay the applicable monthly instalment amount
                      communicated at the time of enrolment by the Company. The
                      monthly instalment amount applicable to the selected plan
                      shall remain fixed throughout the Tenure and no payment of
                      a lesser amount shall be accepted towards any monthly
                      instalment. Acceptance of any payment exceeding the
                      prescribed monthly instalment amount shall be at the sole
                      discretion of the Company and subject to the Company’s
                      prevailing policies.
                    </li>

                    <li>
                      3. To enroll in the Subscription Plan, the Customer shall
                      open a subscription account (“Subscription Account”) at
                      any authorized Limelight store by completing the enrolment
                      formalities prescribed by the Company. The Company and/or
                      its authorized representatives may assist the Customer in
                      the enrolment process. A Customer may open and maintain
                      multiple Subscription Accounts under the Subscription
                      Plan; however, each Subscription Account shall be treated
                      as separate and independent, with its own rights,
                      obligations, benefits and liabilities.
                    </li>

                    <li>
                      4. To be eligible to enroll in the Subscription Plan, the
                      Customer must be at least 18 (eighteen) years of age, be a
                      resident of India, and furnish such identity proof,
                      address proof, PAN card, Aadhaar card and other documents
                      or information as may be required by the Company for
                      verification, compliance and activation of the
                      Subscription Account. The Customer represents and warrants
                      that all information and documents provided to the Company
                      are true, accurate, complete and up to date. It is hereby
                      clarified that the Subscription Plan is available only to
                      Indian resident individuals and is not available to
                      companies, partnership firms, proprietorship concerns,
                      trusts, Hindu Undivided Families (HUFs), non-resident
                      Indians (NRIs) or any other artificial juridical persons.
                    </li>

                    <li>
                      5. The Customer shall make the first monthly instalment at
                      the time of opening the Subscription Account. The date on
                      which the first instalment is received by the Company
                      shall be deemed to be the enrolment date (“Enrolment
                      Date”).
                    </li>

                    <li>
                      6. Upon successful payment of all 10 (ten) monthly
                      instalments within the Tenure and compliance with these
                      Terms and Conditions, the Company shall contribute an
                      amount equivalent to 1 (one) monthly instalment on behalf
                      of the Customer and issue a voucher equivalent to the
                      aggregate value of 11 (eleven) monthly instalments. The
                      Company's contribution of the additional monthly
                      instalment shall constitute the sole benefit under the
                      Subscription Plan, and no other discount, rebate,
                      cashback, reward points, price reduction, making charge
                      waiver or similar benefit shall be available unless
                      expressly permitted by the Company in writing.
                    </li>

                    <li>
                      7. The Subscription Account shall remain valid for a
                      period of 400 (four hundred) days from the Enrolment Date
                      (“Subscription End Date”). During the Tenure, the Customer
                      shall pay the applicable monthly instalment on or before
                      the corresponding date of each subsequent month (“Due
                      Date”). Any overdue instalment may be paid along with the
                      subsequent instalment, subject to the Subscription Account
                      remaining active and compliant with these Terms and
                      Conditions. In the event the Customer fails to pay 2 (two)
                      consecutive monthly instalments, the Company shall have
                      the right to terminate the Subscription Account without
                      any further notice, and the Customer’s rights shall
                      thereafter be governed in accordance with the cancellation
                      provisions of these Terms and Conditions. Upon such
                      termination, the Customer shall not be entitled to the
                      benefit of the additional monthly instalment contributed
                      by the Company, and the Company shall issue a voucher
                      equivalent only to the amount actually paid by the
                      Customer under the Subscription Plan. Such voucher shall
                      be subject to the terms, conditions and validity
                      applicable under the Subscription Plan.
                    </li>

                    <li>
                      8. The benefits under the Subscription Plan shall be
                      available only if:
                      <ul style={{ padding: "0 30px" }}>
                        <li>
                          a. all instalments have been paid in accordance with
                          the Subscription Plan;
                        </li>
                        <li>
                          b. the Subscription Account remains active and
                          compliant with these Terms and Conditions;
                        </li>
                        <li>
                          c. redemption is completed on or before the
                          Subscription End Date; and
                        </li>
                        <li>
                          d. the purchase is made from an authorized Limelight
                          store as per the terms of the issued voucher/coupon.
                        </li>
                      </ul>
                    </li>

                    <li>
                      9. A voucher issued under the Subscription Plan may be
                      redeemed only once towards the purchase of eligible
                      jewellery products from authorized Limelight stores. Where
                      the purchase value exceeds the voucher amount, the
                      Customer shall pay the differential amount through such
                      payment modes as may be accepted by the Company. In the
                      event the purchase value is less than voucher amount, the
                      unutilized voucher balance shall lapse and shall not be
                      refundable, credited or carried forward in anyway
                      whatsoever.
                    </li>

                    <li>
                      10. The Subscription Account is personal to the Customer,
                      non-transferable and non-assignable. Upon expiry of the
                      Subscription End Date, the Subscription Account shall
                      automatically stand closed.
                    </li>

                    <li>
                      11. The Customer may nominate an individual above the age
                      of 18 (eighteen) years at the time of enrolment. In the
                      event of the Customer's death, the nominee may, subject to
                      verification and submission of documents as required by
                      the Company, continue the Subscription Plan, pay any
                      pending instalments and redeem the benefits available
                      under the Subscription Plan.
                    </li>

                    <li>
                      12. Instalments shall be paid through such payment modes
                      as may be approved by the Company including but limited to
                      UPI, cash payments at authorized Limelight stores. The
                      Company shall not be liable for delays, failures or
                      interruptions attributable to banks, payment gateways or
                      third-party payment service providers.
                    </li>

                    <li>
                      13. In the event the Customer voluntarily discontinues,
                      cancels or terminates participation in the Subscription
                      Plan prior to completion of the Tenure, no cash refund
                      shall be provided. The Company shall issue a voucher
                      equivalent to the amount paid by the Customer under the
                      Subscription Plan, which may be utilized by the Customer
                      within 6 (six) months from the date of voucher issuance or
                      before Subscription End Date, whichever is earlier,
                      subject to such usage restrictions and conditions as may
                      be prescribed by the Company.
                    </li>

                    <li>
                      14. If the Customer fails to redeem the accumulated value
                      under the Subscription Plan on or before the Subscription
                      End Date, the Subscription Account shall automatically
                      stand closed. Upon such closure, the Company may refund
                      the principal amount paid by the Customer under the
                      Subscription Plan through the prescribed banking channels,
                      without any interest. The additional benefit equivalent to
                      1 (one) monthly instalment contributed by the Company
                      shall not be provided to the Customer in cash and shall
                      instead be issued as a voucher of equivalent value, valid
                      for 6 (six) months from the date of issuance. Such voucher
                      may be utilized only towards the purchase of eligible
                      jewellery products after the Customer has fully utilized
                      the refunded principal amount and shall be
                      non-transferable, non-refundable and subject to the
                      Company's applicable terms and conditions.
                    </li>

                    <li>
                      15. Except as expressly provided under Clause 14, the
                      Customer shall not be entitled to any cash refund, bank
                      transfer, interest, return, compensation or monetary
                      payout against any amount paid under the Subscription
                      Plan. The Customer's entitlements under the Subscription
                      Plan shall be limited to redemption and/or utilization of
                      vouchers issued in accordance with these Terms and
                      Conditions. In exceptional circumstances, including but
                      not limited to cancellation of the Subscription Account by
                      the Company due to discrepancies in Customer information,
                      failure to complete KYC requirements, regulatory
                      requirements, fraud prevention measures, breach of these
                      Terms and Conditions, or any other circumstance where the
                      Company determines that issuance of a voucher is not
                      feasible, the Company may, at its sole discretion, refund
                      the amount paid by the Customer under the Subscription
                      Plan.
                    </li>

                    <li>
                      16. Any refund approved by the Company shall be made only
                      through electronic transfer by way of NEFT, RTGS or such
                      other banking channel as may be determined by the Company,
                      to the bank account details provided by the Customer and
                      duly verified by the Company. The mode, timing and process
                      of such refund shall be determined by the Company in
                      accordance with its prevailing internal policies and
                      applicable laws.
                    </li>

                    <li>
                      17. Coins, loose solitaires, plain gold products,
                      MRP-based products, accessories and such other products as
                      may be specified by the Company at the time of redemption
                      shall not be eligible for purchase under the Subscription
                      Plan.
                    </li>  */}

                    <li>
                      18. The benefits available under the Subscription Plan may
                      be combined with promotional campaigns, festive offers and
                      marketing programmes expressly approved by the Company.
                      However, the Subscription Plan shall not be combined with
                      the “Redefine” scheme or any other offer specifically
                      excluded by the Company at its discretion.
                    </li>
                    <li>
                      19. The Company reserves the right to suspend, reject,
                      cancel or terminate a Subscription Account in the event of
                      fraud, misrepresentation, submission of inaccurate
                      information, failure to complete KYC requirements, breach
                      of these Terms and Conditions or any unlawful activity. In
                      such cases, the Company may at its discretion issue a
                      voucher equivalent to the amount paid by the Customer.
                    </li>

                    <li>
                      20. The Customer shall promptly notify the Company of any
                      change in name, address, contact details, banking
                      information or any other information provided at the time
                      of enrolment.
                    </li>

                    <li>
                      21. The Company reserves the right to modify, amend or
                      discontinue the Subscription Plan, provided that such
                      modification shall not adversely affect benefits already
                      accrued by Customers who have enrolled prior to such
                      modification.
                    </li>

                    <li>
                      22. The Subscription Plan is a customer jewellery purchase
                      programme and shall not be construed as a deposit scheme,
                      investment scheme, savings scheme, chit fund, collective
                      investment scheme, financial product or banking product.
                      No interest shall accrue or be payable on any amount paid
                      by the Customer under the Subscription Plan.
                    </li>

                    <li>
                      23. The Company's aggregate liability arising out of or in
                      connection with the Subscription Plan shall in no event
                      exceed the total amount paid by the Customer under the
                      Subscription Plan. In no event shall the Company be liable
                      for any indirect, incidental, special, punitive or
                      consequential loss or damage, including loss of profits,
                      business, goodwill or data, arising out of or in
                      connection with the Subscription Plan
                    </li>

                    <li>
                      24. The Company shall not be liable for any delay or
                      failure in performance arising due to events beyond its
                      reasonable control, including acts of God, natural
                      disasters, governmental actions, pandemics, strikes, labor
                      disputes, system failures, cyber incidents or
                      interruptions in communication networks.
                    </li>

                    <li>
                      25. The Customer expressly consents to the collection,
                      storage, processing, use and retention of their personal
                      information, contact details and documents by the Company
                      for the purposes of enrolment, administration and
                      operation of the Subscription Plan, verification of
                      identity, customer support, compliance with applicable
                      laws, and such other business purposes as may be
                      reasonably required by the Company. The Customer further
                      authorizes the Company and its affiliates, group
                      companies, franchisees, authorized representatives and
                      service providers to contact the Customer through
                      telephone calls, SMS, WhatsApp, e-mail or other
                      communication channels regarding products, jewellery
                      collections, promotional campaigns, offers, subscription
                      plans, loyalty programmes and other marketing initiatives.
                      Such collection, storage, processing and use of personal
                      information shall be subject to the Company's privacy
                      policy and applicable laws.
                    </li>

                    <li>
                      26. Any matter not expressly covered under these Terms and
                      Conditions shall be determined by the Company.
                    </li>

                    <li>
                      27. The Company’s prevailing return, exchange, buyback and
                      product warranty policies shall apply to all purchases
                      made under the Subscription Plan.
                    </li>

                    <li>
                      28. These Terms and Conditions shall be governed by and
                      construed in accordance with the laws of India and the
                      courts at Mumbai shall have exclusive jurisdiction over
                      any dispute arising out of or in connection with the
                      Subscription Plan.
                    </li>

                    <li>
                      29. No failure, delay or omission by the Company in
                      exercising any right, power, remedy or privilege under
                      these Terms and Conditions shall operate as a waiver
                      thereof, nor shall any single or partial exercise of any
                      such right, power, remedy or privilege preclude any other
                      or further exercise thereof or the exercise of any other
                      right, power, remedy or privilege. Any waiver by the
                      Company shall be valid only if made expressly in writing
                      and shall apply only to the specific instance for which
                      such waiver is granted.
                    </li>

                    <li>
                      30. If any provision of these Terms and Conditions is held
                      to be invalid, illegal, unenforceable or void by a court
                      or other competent authority, such provision shall, to the
                      extent of such invalidity, illegality or unenforceability,
                      be deemed severed from these Terms and Conditions without
                      affecting the validity, legality or enforceability of the
                      remaining provisions, which shall continue in full force
                      and effect. The parties intend that any such invalid,
                      illegal or unenforceable provision shall be interpreted
                      or, where necessary, replaced with a valid and enforceable
                      provision that most closely reflects the original
                      commercial intent of the parties, to the extent permitted
                      by applicable law.
                    </li>

                    <li>
                      31. All applicable taxes, statutory levies and regulatory
                      requirements shall apply. Any query, complaint or
                      grievance relating to the Subscription Plan may be
                      addressed to the Company`s Grievance Officer at
                      ______________ (E-mail) or ____________ (Customer Care
                      Number), or at the authorized Limelight store in writing
                      where the Subscription Account was opened.
                    </li>
                  </ul>

                  <HStack justifyContent="space-around" w="100%" mt="8">
                    <VStack spacing="2">
                      <Box w="200px" h="1px" bg="black" />
                      <Text fontSize="10px">Authorized Signature</Text>
                      <Text fontSize="10px">
                        Date : {state.enrollment_date}
                      </Text>
                    </VStack>

                    <VStack spacing="2">
                      <Box w="200px" h="1px" bg="black" />
                      <Text fontSize="10px">Customer Signature</Text>
                      <Text fontSize="10px">
                        Date : {state.enrollment_date}{" "}
                      </Text>
                    </VStack>
                  </HStack>
                </VStack>
              </Container>
            </VStack>
          </Box>
        </VStack>
      </Container>
    </>
  );
}
